import React from 'react';
import PropTypes from 'prop-types';

import { Grid, Cell } from '../../base/styled';

import {
  LabelWidget,
  NumberWidget,
  NewRelicTableWidget,
} from '../../widgets';

const NewRelicZenoss = (props) => {

  const {
    title,
    alerts: {
      error = null,
      data: {
        'zenoss-warning-count': zenossWarningCount = {},
        'zenoss-error-count': zenossErrorCount = {},
        'zenoss-critical-count': zenossCriticalCount = {},
        'zenoss-table': zenossTable = {},
      } = {},
    } = {},
  } = props;

  return (
    <div className="dashboard">
      <Grid columns={3} rows="75px 160px 1fr" alignContent="stretch" height="inherit">
        <Cell width={3}>
          <LabelWidget input={{ data: { title } }} />
        </Cell>
        <Cell width={1}>
          <NumberWidget input={{ error, data: zenossCriticalCount }} />
        </Cell>
        <Cell width={1}>
          <NumberWidget input={{ error, data: zenossErrorCount }} />
        </Cell>
        <Cell width={1}>
          <NumberWidget input={{ error, data: zenossWarningCount }} />
        </Cell>
        <Cell width={3}>
          <NewRelicTableWidget input={{ error, data: zenossTable }} />
        </Cell>
      </Grid>
    </div>
  );
};

NewRelicZenoss.defaultProps = null;

NewRelicZenoss.propTypes = {
  title: PropTypes.string.isRequired,
  alerts: PropTypes.shape({
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    data: PropTypes.shape({
      'zenoss-warning-count': NumberWidget.dataPropType,
      'zenoss-error-count': NumberWidget.dataPropType,
      'zenoss-critical-count': NumberWidget.dataPropType,
      'zenoss-table': NewRelicTableWidget.dataPropType,
    }),
  }),
};

export default NewRelicZenoss;
